const refs = 'news'
export default [
    { 
        path: '/'+refs, 
        name: refs, 
        component: () => import('@/views/'+refs+'/List.vue')
    },
    { 
        path: '/'+refs+'/:slug', 
        name: 'show-'+refs, 
        component: () => import('@/views/'+refs+'/Show.vue')
    },
]
